import { Checkbox, DateInput, Group, Stack, Text, TimeInput } from '@ekhodealer/ekho-common/rev';

import type { Time } from '@internationalized/date';

import { useDiscountFieldError, useDiscountFormField } from '../../atoms/discountFormAtoms';

export const DiscountActiveDatesSection = () => {
	const [startDate, setStartDate] = useDiscountFormField('startDate');
	const [startTime, setStartTime] = useDiscountFormField('startTime');
	const [hasEndDate, setHasEndDate] = useDiscountFormField('hasEndDate');
	const [endDate, setEndDate] = useDiscountFormField('endDate');
	const [endTime, setEndTime] = useDiscountFormField('endTime');
	const startDateError = useDiscountFieldError('startDate');
	const endDateError = useDiscountFieldError('endDate');

	return (
		<Stack itemsSpacing='16'>
			<Text size='body' weight='semibold'>
				3. Active dates
			</Text>

			<Group itemsSpacing='8' noWrap>
				<Group.Item grow={1}>
					<DateInput label='Start date' value={startDate} onChange={setStartDate} size='medium' hasError={startDateError} />
				</Group.Item>
				<Group.Item grow={1}>
					<Stack itemsSpacing='4'>
						<Text size='footnote'>Start time</Text>
						<TimeInput value={startTime} onChange={(value) => setStartTime(value as Time | null)} />
					</Stack>
				</Group.Item>
			</Group>

			<Checkbox
				label='Set end date'
				isSelected={hasEndDate}
				onChange={setHasEndDate}
			/>

			{hasEndDate && (
				<Group itemsSpacing='8' noWrap>
					<Group.Item grow={1}>
						<DateInput label='End date' value={endDate} onChange={setEndDate} size='medium' hasError={endDateError} />
					</Group.Item>
					<Group.Item grow={1}>
						<Stack itemsSpacing='4'>
							<Text size='footnote'>End time</Text>
							<TimeInput value={endTime} onChange={(value) => setEndTime(value as Time | null)} />
						</Stack>
					</Group.Item>
				</Group>
			)}
		</Stack>
	);
};
